export const SET_TOKEN = 'auth/setToken';
